import script from "./CustomerIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerIndex.vue?vue&type=script&setup=true&lang=js"

import "./CustomerIndex.vue?vue&type=style&index=0&id=3a0571a1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0571a1"]])

export default __exports__